import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { MediaHelper } from '../../helpers/mediaHelper';
import { DataHubService } from 'src/core/services/datahub';
import { ViewExtraMaterialSchema } from 'src/core/services/datahub/schemas/content/viewExtraMaterialSchema';
import Collapse from 'src/shared/components/collapse';
import RenderClubAdmin from 'src/shared/components/renderClubAdmin/renderClubAdmin';
export function AdditionalMaterials() {
    const { t } = useTranslation();
    const { pageId } = useParams();
    const form = useFormContext();
    const attachments = form.watch('attachments');
    const complementaryReadings = form.watch('complementaryReadings');
    const shouldCollapseStartOpen = Boolean(attachments?.length || complementaryReadings.length);
    const [isOpen, setIsOpen] = useState(shouldCollapseStartOpen);
    useEffect(function effectDispatchEvent() {
        if (isOpen) {
            DataHubService.sendEvent({
                schema: new ViewExtraMaterialSchema({
                    arrivedFrom: window.location.href
                })
            });
        }
    }, [isOpen]);
    function handleAttachmentsChange(newAttachments) {
        if (MediaHelper.isEqualMedias(attachments, newAttachments)) {
            return;
        }
        form.setValue('attachments', newAttachments, { shouldDirty: true });
    }
    function handleComplementaryReadingsChange(value) {
        form.setValue('complementaryReadings', value, { shouldDirty: true });
    }
    return (_jsxs(Collapse, { startOpen: shouldCollapseStartOpen, onClick: () => setIsOpen((prev) => !prev), children: [_jsx(Collapse.Header, { children: t('content.form.extra_material.title') }), _jsxs(Collapse.Body, { children: [_jsx(RenderClubAdmin, { __name: "FileAttachmentSection", files: attachments, onChange: handleAttachmentsChange, ...(pageId !== 'new' && { entityId: pageId }) }), _jsx(RenderClubAdmin, { __name: "ComplementaryReading", className: "_mt-5", onArticleChange: handleComplementaryReadingsChange, articles: complementaryReadings })] })] }));
}
